import { render, staticRenderFns } from "./CoursewareContainerAdderItem.vue?vue&type=template&id=3443a4c8&"
import script from "./CoursewareContainerAdderItem.vue?vue&type=script&lang=js&"
export * from "./CoursewareContainerAdderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports